import React from "react";
import { useNavigate } from "react-router-dom";
import "./News.css";

import { Modal_carousel } from "../../components";

import { Underline } from "../../widgets";

import { news_info } from "../../constants/news_info";


const News = () => {
  const navigate = useNavigate();
  return (
    <div className="blogs">
      <div className="news_heading">
      <Underline heading="News"/>
      </div>
      <Modal_carousel info={news_info}/>
    
      <div
        className="read_more read_button"
        onClick={() => navigate("/iqac_programmes")}
      >
        View More
      </div>
    </div>
  );
};

export default News;
